export const TOOLTIP_POSITION_CHANGE_EVENT_NAME = "tooltip-position-change";
